function Copy() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 -960 960 960" width="18">
      <path d="M385.392-213.957q-50.508 0-86.733-36.224-36.224-36.225-36.224-86.733v-472.173q0-50.508 36.224-86.733 36.225-36.225 86.733-36.225h352.173q50.508 0 86.45 36.225t35.942 86.733v472.173q0 50.508-35.942 86.733-35.942 36.224-86.45 36.224H385.392Zm0-122.957h352.173v-472.173H385.392v472.173ZM182.435-11.564q-50.508 0-86.45-35.943-35.942-35.942-35.942-86.45v-595.13h122.392v595.13h475.13v122.392h-475.13Zm202.957-325.35v-472.173 472.173Z" />
    </svg>
  );
}

export default Copy;
